import React, { useMemo, useState } from "react";
import { Email, WhatsApp } from "@material-ui/icons";
import { IconModal } from "../../IconModal";
import { Container } from "./styles";
import { Checkbox, FormControlLabel, List, ListItem } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import * as http from "modules/app/utils/http";
import { useParams } from "react-router";
import { toast } from "react-toastify";

function ReplySources({ replySources, setReplySources }) {
  const { t } = useTranslation("Chat");
  const [open, setOpen] = useState(false);
  const { id } = useParams();

  const iconsSource = {
    whatsapp: <WhatsApp />,
    email: <Email 
      style={{
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        borderRadius:'50%'
      }}
    />,
  };

  const totalSources = useMemo(() => {
    let total = 0;

    if (replySources) {
      Object.keys(replySources).forEach(
        (key) => replySources[key] && replySources[key].checked && total++
      );
    }

    return total;
  }, [replySources]);

  function changeReplySource(replySource) {
    if (totalSources != 1 || !replySource.checked) {
      const newReplySources = {
        ...replySources,
        [replySource.name]: {
          name: replySource.name,
          checked: !replySource.checked,
        },
      };

      setReplySources(newReplySources);

      http
        .updateReplySources(id, newReplySources)
        .then(() => toast.success("Canais atualizados com sucesso"));
    }
  }

  function replySourceIcon(replySource) {
    if (totalSources == 0) return iconsSource[replySource.name];

    if (replySource.checked) return iconsSource[replySource.name];
  }

  return (
    <IconModal
      title={t("replySources.title")}
      icon={
        <Container>
          {Object.keys(replySources).map((key) => (
            <span key={key}>{replySourceIcon(replySources[key])}</span>
          ))}
        </Container>
      }
      handleOpenModal={() => {}}
      open={open}
      setOpen={setOpen}
    >
      <List>
        {Object.keys(replySources).map((key) => (
          <ListItem key={key}>
            <FormControlLabel
              control={
                <Checkbox
                  onClick={() => changeReplySource(replySources[key])}
                  checked={replySources[key].checked}
                  name={t(`replySources.${replySources[key].name}`)}
                  color="primary"
                />
              }
              label={t(`replySources.${replySources[key].name}`)}
            />
          </ListItem>
        ))}
      </List>
    </IconModal>
  );
}

export default ReplySources;
